export default function Projects({ name }) {
	const projectId = Date.now().toString(36) + Math.random().toString(36).substring(2, 12).padStart(12, 0);
	let tasks = [];

	return Object.freeze({
		get projectId() { return projectId },
		get name() { return name; },
		set name(newName) { name = newName; },
		get tasks() { return tasks; },
		set tasks(newTasks) { tasks = newTasks; },
	});
}
